import { DEV_SCRIPT_URL, PROD_SCRIPT_URL } from './providers/NitroAds';
import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getAdsSSRConfig(session) {
    var _session_features;
    if (!session.adsEnabled) {
        return {
            shouldIncludeNitro: false,
            shouldIncludeGak: false,
            nitroUrl: ''
        };
    }
    if ((_session_features = session.features) === null || _session_features === void 0 ? void 0 : _session_features.includes('ads_da')) {
        return {
            shouldIncludeNitro: false,
            shouldIncludeGak: true,
            gakContext: toJsonString({
                features: session.features.reduce((p, c)=>{
                    p[c] = true;
                    return p;
                }, {})
            })
        };
    }
    return {
        shouldIncludeNitro: true,
        shouldIncludeGak: false,
        nitroUrl: process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm' ? DEV_SCRIPT_URL : PROD_SCRIPT_URL
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
